import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	ticket: null,
	loading: false
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_TRANSACTION_CB_JSUP_PAGE_REQUEST:
		case ActionTypes.GET_TRANSACTION_CB_JSUP_PAGE_ERROR:
		case ActionTypes.GET_TRANSACTION_CB_JSUP_PAGE_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_CB_JSUP_PAGE_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_CB_JSUP_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
